import store from '@/store/'


export default {
    auth(to, from, next) {
        next()

        store.dispatch('filial/loadFromLocalStoragePainel')

        if (to.fullPath !== '/loginPainel' && !store.getters['filial/filialPainel']) {
            next('/loginPainel')
        }
        
        next()
    }
}